import React, { useCallback } from 'react';
import { Box, Flex, PopoverV2, useDisclosure } from '@withjoy/joykit';
import { ChevronDown } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { SortOption } from '@apps/accommodations/AccommodationsConsole.types';
import { DropdownButton } from './DropdownButton';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import { SortOptionsFacet } from './SortOptionsFacet';
import { useSortOptions } from '@apps/accommodations/hooks/useSortOptions';

interface SortComponentProps {
  selectedValue: SortOption;
  onChange: (value: SortOption) => void;
}

export const SortComponent: React.FC<SortComponentProps> = ({ selectedValue, onChange }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobileOrTablet = useIsMobileOrTablet();
  const { getSelectedOptionLabel, sortTrans } = useSortOptions();

  const handleSortChange = useCallback(
    (value: SortOption) => {
      onChange(value);
      if (!isMobileOrTablet) {
        onClose();
      }
    },
    [onChange, isMobileOrTablet, onClose],
  );

  const SortContent = (
    <Box
      padding={isMobileOrTablet ? pxToRem(24) : 7}
      minWidth={isMobileOrTablet ? '100%' : pxToRem(380)}
    >
      <SortOptionsFacet
        selectedValue={selectedValue}
        onChange={handleSortChange}
      />
    </Box>
  );

  const filterButtonIconSize = 16;
  const trigger = (
    <DropdownButton
      text={`${sortTrans.sortPrefix()} ${getSelectedOptionLabel(selectedValue)}`}
      endIcon={<ChevronDown size={filterButtonIconSize} />}
    />
  );

  return (
    <Flex position={isMobileOrTablet ? 'unset' : 'relative'}>
      <Box onClick={onOpen}>{trigger}</Box>
      <PopoverV2
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        placement="bottom"
        overrides={{
          Root: { props: { minWidth: pxToRem(280), top: isMobileOrTablet ? 80 : 8, left: isMobileOrTablet ? -28 : 'none', right: isMobileOrTablet ? 'none' : 0 } },
          Content: {
            props: {
              borderRadius: pxToRem(24),
              style: { userSelect: 'none' },
            },
          },
        }}
      >
        <PopoverV2.Content>{SortContent}</PopoverV2.Content>
      </PopoverV2>
    </Flex>
  );
};
